import { PERMISSIONS } from "@constants/user.roles";
import { EVENT_MANAGEMENT_BROWSER_ROUTES } from "./browser.routes";
import {
	canAccessEventsCloneModule,
	canAccessEventsRequestModule,
	EVENT_CREATION_ACCESS_PERMISSIONS,
} from "./permissions";

export const EVENT_MANAGEMENT_PATH_PERMISSION_ENTRIES = [
	{
		pattern: EVENT_MANAGEMENT_BROWSER_ROUTES.EVENT_CREATION,
		permission: PERMISSIONS.VIEW_EVENT,
		alternatePermissions: [
			PERMISSIONS.CREATE_EVENT,
			PERMISSIONS.EDIT_EVENT,
			PERMISSIONS.DELETE_EVENT,
		],
	},
	{
		pattern: EVENT_MANAGEMENT_BROWSER_ROUTES.EVENTS_REQUEST,
		permission: PERMISSIONS.VIEW_EVENT,
		alternatePermissions: [PERMISSIONS.EDIT_EVENT],
	},
	{
		pattern: EVENT_MANAGEMENT_BROWSER_ROUTES.EVENTS_CLONE,
		permission: PERMISSIONS.CLONE_CALENDAR_EVENT,
	},
] as const;

export const EVENT_MANAGEMENT_ORDERED_ROUTE_PERMISSIONS: [string, string][] = [
	[EVENT_MANAGEMENT_BROWSER_ROUTES.EVENT_CREATION, PERMISSIONS.VIEW_EVENT],
	[EVENT_MANAGEMENT_BROWSER_ROUTES.EVENTS_REQUEST, PERMISSIONS.VIEW_EVENT],
	[EVENT_MANAGEMENT_BROWSER_ROUTES.EVENTS_CLONE, PERMISSIONS.CLONE_CALENDAR_EVENT],
];

/** Returns path when user may access this event management route; otherwise null. */
export function resolveEventManagementFirstAllowedRoute(
	path: string,
	userPermissions: string[],
	hasAllRead: boolean,
	permissionListIncludesFn: (permissions: string[], permission: string) => boolean,
	context?: {
		roles?: unknown[];
		organizationTypeId?: number | null;
		userTypeName?: string | null;
	},
): string | null {
	if (path === EVENT_MANAGEMENT_BROWSER_ROUTES.EVENT_CREATION) {
		if (
			hasAllRead ||
			EVENT_CREATION_ACCESS_PERMISSIONS.some(permission => permissionListIncludesFn(userPermissions, permission))
		) {
			return path;
		}
	}
	if (path === EVENT_MANAGEMENT_BROWSER_ROUTES.EVENTS_REQUEST) {
		if (
			canAccessEventsRequestModule({
				roles: context?.roles,
				organizationTypeId: context?.organizationTypeId,
				userTypeName: context?.userTypeName,
				userPermissions,
			})
		) {
			return path;
		}
	}
	if (path === EVENT_MANAGEMENT_BROWSER_ROUTES.EVENTS_CLONE) {
		if (canAccessEventsCloneModule(userPermissions)) {
			return path;
		}
	}
	return null;
}
